import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../FreeCataloges.jsx/FreeCataloge.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGauge,
  faShieldHalved,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

const products = [
  { id: 1, name: "Ghee", image: "./assets/ghee1.jpeg" },
  { id: 3, name: "Desi Ghee", image: "./assets/ghee2.jpeg" },
  { id: 5, name: "Dairy Products", image: "./assets/ghee3.jpeg" },
  { id: 6, name: "Milk Products", image: "./assets/ghee4.jpeg" },
  { id: 1, name: "Organic Foods", image: "./assets/ghee1.jpeg" },
  { id: 1, name: "Ghee", image: "./assets/ghee1.jpeg" },
  { id: 3, name: "Desi Ghee", image: "./assets/ghee2.jpeg" },
  { id: 5, name: "Dairy Products", image: "./assets/ghee3.jpeg" },
  { id: 6, name: "Milk Products", image: "./assets/ghee4.jpeg" },
  { id: 1, name: "Organic Foods", image: "./assets/ghee1.jpeg" },
];

const ShreeMahalakshmi = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [highlight, setHighlight] = useState(false);
  const [swiperInstance, setSwiperInstance] = useState(null);

  const handleReachEnd = () => {
    if (swiperInstance) {
      const isEnd = swiperInstance.isEnd;
      const navigationButton = document.querySelector(".swiper-button-next");
      if (navigationButton) {
        navigationButton.style.display = isEnd ? "none" : "block";
      }
    }
  };

  const handleReachStart = () => {
    if (swiperInstance) {
      const isBeginning = swiperInstance.isBeginning;
      const navigationButton = document.querySelector(".swiper-button-prev");
      if (navigationButton) {
        navigationButton.style.display = isBeginning ? "none" : "block";
      }
    }
  };

  const handleProductClick = () => {
    setActiveSection("products");
  };

  const renderContent = () => {
    switch (activeSection) {
      case "products":
        return (
          <div className="swiper-container">
            <Swiper
              modules={[Autoplay, Navigation, Pagination]}
              slidesPerView={1}
              spaceBetween={10}
              pagination={{ clickable: true }}
              navigation={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              onSwiper={setSwiperInstance}
              onReachEnd={handleReachEnd}
              onReachBeginning={handleReachStart}
              breakpoints={{
                640: { slidesPerView: 2, spaceBetween: 20 },
                768: { slidesPerView: 4, spaceBetween: 40 },
                1024: { slidesPerView: 7, spaceBetween: 30 },
              }}
              className="mySwiper"
            >
              {products.map((product) => (
                <SwiperSlide key={`product-${product.id}`}>
                  <div className="card" onClick={handleProductClick}>
                    <img src={product.image} alt={product.name} />
                    <p>{product.name}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        );

      default:
        return (
          <div>
            <div className="swiper-container">
              <Swiper
                modules={[Autoplay, Navigation, Pagination]}
                slidesPerView={1}
                spaceBetween={10}
                pagination={{ clickable: true }}
                navigation={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                onSwiper={setSwiperInstance}
                onReachEnd={handleReachEnd}
                onReachBeginning={handleReachStart}
                breakpoints={{
                  640: { slidesPerView: 2, spaceBetween: 20 },
                  768: { slidesPerView: 4, spaceBetween: 40 },
                  1024: { slidesPerView: 7, spaceBetween: 30 },
                }}
                className="mySwiper"
              >
                {products.map((product) => (
                  <SwiperSlide key={`product-${product.id}`}>
                    <div className="card">
                      <img src={product.image} alt={product.name} />
                      <p>{product.name}</p>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            <div className="welcome">
              <h1>Welcome to the Shree Mahalakshmi Products Company</h1>
              <p>
                Shree Mahalakshmi Products is a trusted name in the production
                and supply of high-quality ghee. With years of expertise in the
                dairy industry, we specialize in offering pure, rich, and
                traditionally crafted ghee that meets the diverse culinary needs
                of our customers. Our product range includes premium ghee
                varieties tailored for use in households, restaurants, sweet
                shops, and the food processing sector. Available in various
                packaging options and sizes, our ghee is crafted using the
                finest quality milk to ensure a rich aroma, authentic taste, and
                high nutritional value.
              </p>
              <h2>We Deal in All Types of Ghee and Dairy Products</h2>
              <p>
                At Shree Mahalakshmi Products, we prioritize purity and health.
                Our manufacturing processes are carefully designed to retain the
                natural goodness of ghee while adhering to the highest standards
                of hygiene and quality. We also offer customizable packaging
                solutions, enabling businesses to brand and market our ghee
                under their own labels. Customer satisfaction remains our top
                priority. With a strong focus on product quality, timely
                delivery, and competitive pricing, we have established a
                reputation as a reliable partner for businesses and individuals
                seeking superior dairy products. Whether your requirement is
                small or bulk, our team is committed to fulfilling it with
                excellence.
              </p>
              {/* <h2>Our Products :</h2> */}
              <p>
                At Shree Mahalakshmi Products, we understand that every customer
                has unique preferences and health requirements. That’s why we
                offer options such as organic ghee, cow ghee, and buffalo ghee,
                catering to a wide range of dietary needs. Our ghee is produced
                using traditional methods combined with modern technology to
                ensure both authentic taste and nutritional benefits.
              </p>
              <p>
                In addition to quality and taste, we prioritize sustainability
                by adopting eco-friendly production practices. Our operations
                focus on minimizing waste and promoting ethical sourcing,
                ensuring that our products align with modern environmental and
                ethical standards. Customer satisfaction is the cornerstone of
                our business. Backed by a dedicated team of professionals, we
                guarantee prompt service, competitive pricing, and outstanding
                after-sales support. Over the years, we have built a loyal
                customer base, thanks to our unwavering commitment to purity,
                quality, and trust.
              </p>
              {/* <p>Unmatched Expertise
                                With years of experience in the elevator industry, our skilled team brings unparalleled knowledge and proficiency to every project.</p> */}

              <li>
                <div className="pro_inner">
                  <div className="pro_img_sec">
                    <img
                      src="./assets/ghee7.jpg"
                      title="Premium Quality Ghee"
                      alt="Premium Quality Ghee"
                      width="202"
                      height="299"
                      decoding="async"
                    />
                  </div>
                  <div className="products_info">
                    <div className="pro_title">
                      <h3>Premium Quality Ghee</h3>
                    </div>
                    <div className="pro_det_sec">
                      <ul className="attributes">
                        <li>
                          <span>Brand:</span> Shree Mahalakshmi Products
                        </li>
                        <li>
                          <span>Product:</span> Pure Desi Ghee
                        </li>
                        <li>
                          <span>Source:</span> Made from premium quality milk
                          using traditional methods
                        </li>
                        <li>
                          <span>Packaging:</span> Available in hygienic,
                          airtight packaging to preserve freshness and flavor
                        </li>
                        <li>
                          <span>Texture:</span> Rich, granular, and aromatic for
                          authentic taste
                        </li>
                        <li>
                          <span>Size Options:</span> 500g, 1kg, 5kg – Various
                          sizes available for retail and bulk needs
                        </li>
                        <li>
                          <span>Color:</span> Natural golden-yellow hue –
                          Indicates purity and richness
                        </li>
                        <li>
                          <span>Usage:</span> Ideal for cooking, sweets, and
                          religious offerings
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </li>
            </div>
          </div>
        );
    }
  };

  return (
    <>
      <div className="company_header">
        <div className="top_head">
          <div className="company_left zdasds">
            <span className="logo_img2" style={{ background: "#d1d786" }}>
              SM
            </span>

            <div className="company_info">
              <div className="company_name2">
                <h1>
                  Shree Mahalakshmi Products{" "}
                  <div className="_oth_info">
                    <a
                      href="https://www.google.co.in/maps/dir//12.9715987,77.5945627"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>
                        <b className="fa fa-map-marker" />
                        Mumbai, Maharashtra, India{" "}
                      </span>
                    </a>
                  </div>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="bottom_head">
          <div className={`Premium-Header ${highlight ? "highlight" : ""}`}>
            <ul className="menu_sec">
              <li>
                Home <FontAwesomeIcon icon={faGauge} />
              </li>
              <li>
                Products <FontAwesomeIcon icon={faShieldHalved} />
              </li>
              <li>
                About Us <FontAwesomeIcon icon={faMessage} />
                <ul className="dropdown"></ul>
              </li>
              <li>
                Contact Us <FontAwesomeIcon icon={faShieldHalved} />
                <ul className="dropdown"></ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {renderContent()}
    </>
  );
};

export default ShreeMahalakshmi;
